import React, { useEffect, useState } from 'react';

import api from '../../../services/api';

import bell from '../../../assets/icons/icon-bell-blue.png';
import IconSearchNotFound from "../../../assets/icons/icons8-search-notfound.png";

import * as S from './styles';
import { theme } from '../../../styles/theme';
import { BodyG, BodyM, TaglineM } from '../../../styles/stylesTypography';

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [isloading, setIsLoading] = useState(true);

  const notificationsSistem = async () => {
    try {
      const response = await api.get(`/notificacoes?limit=5&offset=0`);
      setNotifications(response.data.data); 
    } catch (error) {}

    setIsLoading(false);
  };

  useEffect(() => {
    notificationsSistem();
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate() + 1;
    const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };

  if (isloading) {
    return (
      <S.Container>
        <S.Header> 
          <BodyG color={theme.colors.gray.Cinza_2} fontWeight={700}>
            Notificações
          </BodyG>
          
          <S.ViewAll onClick={() => window.location = '/notificacao'}>
            <img src={bell} alt="Ver todas as notificações" />

            <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>VER TODAS</TaglineM>
          </S.ViewAll>
        </S.Header>

        <S.EventCard style={{ justifyContent: 'center', height: "2.875rem" }}>
          <S.EventInfo>
            <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>Carregando notificações</TaglineM>
          </S.EventInfo>
        </S.EventCard>
      </S.Container>
    )
  }

  return (
    <S.Container>
      <S.Header>
        <BodyG color={theme.colors.gray.Cinza_2} fontWeight={700}>
          Notificações
        </BodyG>

        <S.ViewAll onClick={() => window.location = '/notificacao'}>
          <img src={bell} alt="Ver todas as notificações" />

          <TaglineM color={theme.colors.blue.Azul_link} fontWeight={800}>VER TODAS</TaglineM>
        </S.ViewAll>
      </S.Header>

      <S.CardsScroll>
        {notifications.length > 0 ? (
          notifications.map((notification) => (
            <S.EventCard key={notification.id} hasNotification={notifications.length > 0 ? true : false}>
              <S.EventInfo>
                <S.EventHeader>
                  <S.EventDate>
                    {formatDate(notification.agro_notifications.data)}
                  </S.EventDate>

                  <S.EventNotificator isRead={notification.view - 1}>
                    <p>•</p>
                  </S.EventNotificator>
                </S.EventHeader>

                <BodyM color={theme.colors.gray.Cinza_2} fontWeight={700}>
                  {notification.agro_notifications.titulo_notificacao}
                </BodyM>

                <S.EventText dangerouslySetInnerHTML={{ __html: notification.agro_notifications.texto }} />
              </S.EventInfo>
            </S.EventCard>
          ))
        ) : (
          <S.EventCard>
            <S.EventNotFound>
              <img src={IconSearchNotFound} alt="Ícone de pesquisa" />

              <TaglineM color={theme.colors.gray.Cinza_2} fontWeight={800}>
                Nenhuma notificação encontrada
              </TaglineM>
            </S.EventNotFound>
          </S.EventCard>
        )}
      </S.CardsScroll>
    </S.Container>
  );
};

export default Notifications;
